import moment from 'moment'

export const getters = {
	isUser: state => (state !== null),
	user: state => state,
	count: state => 0,
	isAuthenticated: (state) => {
		if (state) {
			return (state.token !== null && state.token !== undefined)
		} else {
			return false
		}
	},
	isTokenExpired: (state) => state.token_duration && moment(state.token_duration) <= moment(),
	isAnonymous: state => (state.role === 'ANONYMOUS'),
	isEstate: state => state.isEstate,
	isForceCompleteProfile: state => state.isForceCompleteProfile,
	investmentStats: state => state.investment_stats,
	tokenDuration: state => state.token_duration
}



// WEBPACK FOOTER //
// ./src/store/modules/Users/getters.js